/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import * as pageSelectors from "selectors/pageSelectors";
import PageTile from "components/document/page/PageTile";

function mapStoreToProps(stores, ownProps) {
  return {
    tileBitmap: pageSelectors.getTileBitmap(stores, ownProps.pageIndex, ownProps.tileIndex),
    height: pageSelectors.getTileHeight(stores, ownProps.pageIndex, ownProps.tileIndex),
    width: pageSelectors.getTileWidth(stores, ownProps.pageIndex, ownProps.tileIndex),
    top: pageSelectors.getTileTopCoordinate(stores, ownProps.pageIndex, ownProps.tileIndex),
    left: pageSelectors.getTileLeftCoordinate(stores, ownProps.pageIndex, ownProps.tileIndex)
  };
}

const PageTileContainer = inject(mapStoreToProps)(PageTile);

export default PageTileContainer;
